export default __webpack_public_path__ + "static/media/my_turn_inactive.7ccba237.mp3";